import React, { useEffect, useState } from "react";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import callApi from "services/api";
import { useRecoilState, useSetRecoilState } from "recoil";
import { UserState } from "global/UserState";
import { AlertState } from "global/AlertState";
import { loadingState } from "global/LoaderState";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Report = () => {
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [reportType, setReportType] = useState("");
  const [user] = useRecoilState(UserState);
  const [empList, setEmpList] = useState([]);
  const loader = useSetRecoilState(loadingState);
  const [editingData, setEditingData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [masterData, setMasterData] = useState([]);
  const [searchParams, setSearchParams] = useState({
    questionName: "",
    beltNo: "",
    selectedUnit: [],
    selectedRank: [],
    deliquency: [],
    convictionReport: false,
    reportName: "employeeDeliquencyReport",
  });

  const navigate = useNavigate();
  const limit = 10;
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year} `;
  };

  const getAllReportss = async (page = 1) => {
    const params = new URLSearchParams({
      sort_order: "1",
      page: page.toString(),
      limit: limit.toString(),
    });
    let response = await callApi(
      `report/?${params}`,
      "GET",
      null,
      true,
      true,
      (msg) => setError(msg),
      (path) => console.log("navigate to", path),
    );
    if (response.success) {
      const body = response?.body || {};
      setEmpList(body?.data);
      setCurrentPage(body.current_page || 1);
      setTotalPages(body.total_pages || 1);
      setTotalRecords(body.total_count || 0);
    }
  };

  const unitList = masterData?.filter(
    (item) => item?.type === "unit" && item?.name !== "Test Unit",
  );
  const rankList = masterData?.filter((item) => item?.type === "rank");

  const unitOptions = unitList
    ?.filter((unit) => unit.name !== user?.unit)
    .map((unit) => ({
      value: unit.name,
      label: unit.name,
    }));

  const rankOptions = rankList
    ?.filter((rank) => rank.name !== user?.rank)
    .map((rank) => ({
      value: rank.name,
      label: rank.name,
    }));

  const getMaster = async () => {
    try {
      const response = await callApi(
        `filtermaster/data`,
        "GET",
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log("navigate to", path),
      );

      if (response.success) {
        setMasterData(response.body);
      }
    } catch (err) {
      setError("Failed to fetch ");
    }
  };

  useEffect(() => {
    getAllReportss();
    getMaster();
  }, []);

  const renderRows = () => {
    if (!empList || empList?.length === 0) {
      return (
        <tr>
          <td colSpan={9} className="p-3 text-start">
            No Data Found
          </td>
        </tr>
      );
    }

    return empList?.map((item, index) => (
      <tr key={item.id}>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">{item.report_type}</td>
       <td className="text-center">
  {(() => {
    const parsePayload = (payload) => {
      if (!payload) return {};

      try {
        return typeof payload === "string" && payload.startsWith("{")
          ? JSON.parse(
              payload.replace(/'/g, '"').replace(/\bNone\b/g, "null"),
            )
          : payload;
      } catch (err) {
        return {};
      }
    };

    const filterData = parsePayload(item.filter_payload);

    const fieldLabels = {
      unitId: "Unit",
      rank: "Rank",
      search: "Search",
      beltNo: "Belt No",
      deliquencyType: "Deliquency",
      convictionReport: "Conviction Report"
    };
    const deliquencyLabels = {
      fir: "Criminal Case",
      de: "Departmental Action",
      acr: "Adverse Entry in ACR",
    };

    // Create HTML rows
    let filterValues = Object.entries(filterData || {})
      .filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== "" &&
          value !== "None" &&
          (!Array.isArray(value) || value.length > 0),
      )
      .map(([key, value]) => {
        const formattedValue = Array.isArray(value)
          ? value
              .map((item) => deliquencyLabels[item] || item)
              .join(", ")
          : deliquencyLabels[value] || value;

        return `
  <div style="margin-bottom:6px;">
    <span style="font-weight:700; text-transform:uppercase;">
      ${fieldLabels[key] || key}
    </span> :
    <span style="font-weight:400;">
     ${formattedValue}
    </span>
  </div>
`;
      });

    // Handle search_payload separately
    if (
      item.search_payload &&
      item.search_payload !== "None" &&
      item.search_payload !== ""
    ) {
      filterValues.push(`
<div style="margin-bottom:6px;">
  <span style="font-weight:700; text-transform:uppercase;">
    SEARCH
  </span> :
  <span style="font-weight:600;">
    ${item.search_payload}
  </span>
</div>
`);
    }
    if (item.beltNo && item.beltNo !== "None" && item.beltNo !== "") {
      filterValues.push(`
<div style="margin-bottom:6px;">
  <span style="font-weight:700; text-transform:uppercase;">
    BELT NO
  </span> :
  <span style="font-weight:600;">
    ${item.beltNo}
  </span>
</div>
`);
    }
    if (
      item.convictionReport &&
      item.convictionReport !== "None" &&
      item.convictionReport !== ""
    ) {
      filterValues.push(`
<div style="margin-bottom:6px;">
  <span style="font-weight:700; text-transform:uppercase;">
    CONVICTION REPORT
  </span> :
  <span style="font-weight:600;">
     ${item.convictionReport === true || item.convictionReport === "true" ? "Yes" : "No"}
  </span>
</div>
`);
    }

    return filterValues.length > 0 ? (
      <div
        dangerouslySetInnerHTML={{
          __html: filterValues.join(""),
        }}
      />
    ) : (
      "-"
    );
  })()}
</td>
        <td className="text-center">{formatDate(item.created_at)}</td>
        <td className="text-center">{item.status.toUpperCase()}</td>
        <td className="text-center">
          {item.status === "generated" && (
            <>
              <button
                type="button"
                onClick={() => handleAction(item)}
                className="btn btn-sm btn-success me-2"
              >
                Download
              </button>
            </>
          )}
          {item.status === "raised" && (
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </td>
      </tr>
    ));
  };

  const handleAction = async (item) => {
    let response = await callApi(
      `api/employee/download/${item._id.toString()}`, // Fixed: Added slash between transfer and id
      "GET",
      null,
      true,
      true,
      (msg) => setError(msg),
      (path) => console.log("navigate to", path),
    );

    if (response.success) {
      console.log("response.success", response.success); // Fixed: Added parentheses to call the function
    }
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const hasRaisedStatus = empList?.some((item) => item.status === "raised");

    if (!hasRaisedStatus) return;

    let intervalId;

    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        getAllReportss();
      }, 10000);
    }, 10000);

    // Cleanup both timeout and interval
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [empList]);

  const handleSearch = async () => {
    try {
      const deliquencyLabels = {
        fir: "Criminal Case",
        de: "Departmental Action",
        acr: "Adverse Entry in ACR",
      };

      // Create selected filters list
      const selectedFilters = [];

      if (searchParams.questionName) {
        selectedFilters.push(`Search: ${searchParams.questionName}`);
      }

      if (user?.role === "SUPERADMIN") {
        if (searchParams.selectedUnit?.length > 0) {
          selectedFilters.push(`Unit: ${searchParams.selectedUnit.join(", ")}`);
        }
      } else {
        selectedFilters.push(`Unit: ${user?.unitName || user?.unit}`);
      }

      if (searchParams.selectedRank?.length > 0) {
        selectedFilters.push(`Rank: ${searchParams.selectedRank.join(", ")}`);
      }

      if (searchParams.deliquency?.length > 0) {
        selectedFilters.push(
          `Deliquency: ${searchParams.deliquency
            .map((item) => deliquencyLabels[item] || item)
            .join(", ")}`,
        );
      }

      if (searchParams.beltNo) {
        selectedFilters.push(`BeltNo: ${searchParams.beltNo}`);
      }

if (searchParams.convictionReport) {
  selectedFilters.push("Conviction Report: Yes");
}
      const filterMessage =
        selectedFilters.length > 0 ? selectedFilters.join(",<br>") : " ";

      const isFilterApplied = selectedFilters.length > 0;

      const result = await Swal.fire({
        title: "Generate Report?",
        html: `
        <div style="text-align:left">
          <b>
            ${
              isFilterApplied
                ? "Are you sure you want to generate employee deliquency report for the applied filters below"
                : "Are you sure you want to generate employee deliquency report"
            }
          </b>
          <br><br>
          ${filterMessage}
        </div>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Generate",
        cancelButtonText: isFilterApplied ? "Change Filters" : "Apply Filter",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      // Stop if user cancels
      if (!result.isConfirmed) return;

      const queryParams = new URLSearchParams();

      if (searchParams.questionName) {
        queryParams.append("search", searchParams.questionName);
      }

      // Multiple Units
      if (user?.role === "SUPERADMIN") {
        // Selected units from filter
        if (searchParams.selectedUnit?.length > 0) {
          searchParams.selectedUnit.forEach((unit) => {
            queryParams.append("unitId", unit);
          });
        }
      } else {
        // Logged in user's unit
        queryParams.append("unitId", user?.unit);
      }

      // Multiple Ranks
      if (searchParams.selectedRank?.length > 0) {
        searchParams.selectedRank.forEach((rank) => {
          queryParams.append("rank", rank);
        });
      }

      if (searchParams.deliquency?.length > 0) {
        searchParams.deliquency.forEach((item) => {
          queryParams.append("deliquencyType", item);
        });
      }

      if (searchParams.beltNo) {
        queryParams.append("beltNo", searchParams.beltNo);
      }

      queryParams.append("reportName", reportType);

      if (searchParams.convictionReport) {
  queryParams.append("convictionReport", "true");
}

      console.log("searchParams", queryParams.toString());

      let response = await callApi(
        `employee/report?${queryParams}`,
        "GET",
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log("navigate to", path),
      );

      if (response.success) {
        getAllReportss();
        setSearchParams({
          questionName: "",
          selectedUnit: [],
          selectedRank: [],
          deliquency: [],
          beltNo: "",
          convictionReport: false,
        }); 
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  return (
    <>
      <div className="container">
        <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
          <h5 className="card-title  p-3 m-0 text-white">Reports</h5>
        </div>
        <div className="card-body ms-3">
          <>
            <div className="row mb-3 mt-4 ps-4">
              <form
                className="form-inline"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSearch();
                }}
              >
                {/* First Row - Report Type */}
                <div className="row mb-3">
                  <div className="col-md-3">
                    <select
                      className="form-control"
                      value={reportType}
                      onChange={(e) => setReportType(e.target.value)}
                    >
                      <option value="">Select Report Type</option>
                      <option value="employeeReport">Employee Report</option>
                      <option value="employeeDeliquencyReport">
                        Employee Deliquency Report
                      </option>
                    </select>
                  </div>
                </div>

                {/* Second Row */}
                {reportType !== "" && (
                  <div className="row">
                    {/* Employee Report Fields */}
                    <div className="col-md-3">
                      <div
                        className="position-relative w-100"
                        style={{ maxWidth: "400px" }}
                      >
                        <FontAwesomeIcon
                          icon={faMagnifyingGlass}
                          className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                          style={{ pointerEvents: "none" }}
                        />

                        <input
                          type="text"
                          name="questionName"
                          onChange={handleSearchChange}
                          value={searchParams.questionName}
                          placeholder="Enter Name or Unique Id"
                          className="form-control ps-5 py-2"
                          style={{
                            borderRadius: "0.5rem",
                            boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                          }}
                        />
                      </div>
                    </div>

                    {reportType === "employeeReport" && (
                      <>
                        <div className="col-md-2">
                          <div
                            className="position-relative w-100"
                            style={{ maxWidth: "400px" }}
                          >
                            <FontAwesomeIcon
                              icon={faMagnifyingGlass}
                              className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                              style={{ pointerEvents: "none" }}
                            />

                            <input
                              type="text"
                              name="beltNo"
                              onChange={handleSearchChange}
                              value={searchParams.beltNo}
                              placeholder="Enter Belt No"
                              className="form-control ps-5 py-2"
                              style={{
                                borderRadius: "0.5rem",
                                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {user?.role === "SUPERADMIN" && (
                      <div className="col-md-2 ps-3">
                        <Select
                          isMulti
                          isDisabled={loading}
                          name="selectedUnit"
                          options={unitOptions}
                          placeholder="Select Units"
                          value={unitOptions.filter((option) =>
                            searchParams.selectedUnit.includes(option.value),
                          )}
                          onChange={(selectedOptions) => {
                            setSearchParams((prev) => ({
                              ...prev,
                              selectedUnit: selectedOptions
                                ? selectedOptions.map((item) => item.value)
                                : [],
                            }));
                          }}
                        />
                      </div>
                    )}

                    <div className="col-md-2 ps-3">
                      <Select
                        isMulti
                        isDisabled={loading}
                        name="selectedRank"
                        options={rankOptions}
                        placeholder="Select Ranks"
                        value={rankOptions.filter((option) =>
                          searchParams.selectedRank.includes(option.value),
                        )}
                        onChange={(selectedOptions) => {
                          setSearchParams((prev) => ({
                            ...prev,
                            selectedRank: selectedOptions
                              ? selectedOptions.map((item) => item.value)
                              : [],
                          }));
                        }}
                      />
                    </div>

                    {reportType === "employeeDeliquencyReport" && (
                      <>
                        <div className="col-md-3 ps-3">
                          <Select
                            isMulti
                            isDisabled={loading}
                            name="deliquency"
                            options={[
                              { value: "fir", label: "Criminal Case" },
                              { value: "de", label: "Departmental Action" },
                              { value: "acr", label: "Adverse Entry in ACR" },
                            ]}
                            placeholder="Select Deliquency"
                            value={[
                              { value: "fir", label: "Criminal Case" },
                              { value: "de", label: "Departmental Action" },
                              { value: "acr", label: "Adverse Entry in ACR" },
                            ].filter((option) =>
                              searchParams.deliquency.includes(option.value),
                            )}
                            onChange={(selectedOptions) => {
                              setSearchParams((prev) => ({
                                ...prev,
                                deliquency: selectedOptions
                                  ? selectedOptions.map((item) => item.value)
                                  : [],
                              }));
                            }}
                          />
                        </div>

                          <div className="col-md-2 ps-3 d-flex align-items-center">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="convictionReport"
                          checked={searchParams.convictionReport}
                          onChange={(e) =>
                            setSearchParams((prev) => ({
                              ...prev,
                              convictionReport: e.target.checked,
                            }))
                          }
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="convictionReport"
                        >
                          Conviction Report
                        </label>
                      </div>
                    </div>
                      </>
                    )}

                    <div className="col-md-2 ps-3">
                      <button
                        type="submit"
                        className="btn btn-l btn-outline-info"
                        disabled={loading}
                      >
                        Generate Request
                      </button>
                    </div>
                  </div>
                )}
              </form>
            </div>
            <div className="mt-4 table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="text-center">S.no</th>
                    <th className="text-center">Report Name</th>
                    <th className="text-center">Report Parameters</th>
                    <th className="text-center">Genrated On</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>{renderRows()}</tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Page {currentPage} of {totalPages} | Total Records:{" "}
                {totalRecords}
              </div>

              <div>
                <button
                  disabled={currentPage === 1}
                  onClick={() => getAllReportss(currentPage - 1)}
                  className="btn btn-sm btn-outline-primary me-2"
                >
                  Previous
                </button>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => getAllReportss(currentPage + 1)}
                  className="btn btn-sm btn-outline-primary"
                >
                  Next
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Report;
